<template>
  <div class="content_box">
    <div class="title">
      <span class="left_shu"></span>
      播放热图
      <div class="screen_box">
        <div class="screen_title">选择参数：</div>
        <el-select v-model="value" placeholder="请选择" @change="choiceType">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="screen_title">选择日期：</div>
        <el-date-picker
          v-model="value1"
          type="date"
          value-format="yyyy-MM-dd"
          @change="choiceTime"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <div class="screen_title">切换设备：</div>
        <el-select v-model="deviceType" placeholder="请选择">
          <el-option
            v-for="item in deviceTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            @change="changeSomeThing()"
          >
          </el-option>
        </el-select>
        <a-button
          class="creatadd"
          :type="isPlay ? 'info' : 'primary'"
          @click="play"
        >
          <i
            :class="isPlay ? 'el-icon-video-pause' : 'el-icon-video-play'"
            style="margin-right: 5px"
          ></i>
          {{ isPlay ? "暂停播放" : "开始播放" }}
        </a-button>
      </div>
    </div>
    <div class="operation">
      <!-- <div class="sinput">
				<input type="text" placeholder="请输入策略名称查询" />
				<img src="../../assets/image/37.png" />
			</div> -->
      <div class="block">
        <el-slider
          v-model="timeSection"
          :min="1"
          :marks="marks"
          :max="maxSlider"
          show-stops
          range
          @change="section"
        >
        </el-slider>
      </div>
    </div>
    <div class="operation">
      <!-- <div class="sinput">
				<input type="text" placeholder="请输入策略名称查询" />
				<img src="../../assets/image/37.png" />
			</div> -->
      <div class="block">
        <el-slider
          v-if="silderVisible"
          v-model="timePos"
          :max="stepNum"
          :format-tooltip="formatTooltip"
          :min="1"
        >
        </el-slider>
      </div>
    </div>
    <div class="Map_box">
      <baidu-map
        :center="{ lng: 118.82956267730716, lat: 31.876923009327903 }"
        :zoom="18"
        :scroll-wheel-zoom="true"
        style="width: 100%; height: 100%"
      >
        <bml-heatmap
          v-if="visible"
          :data="descedPoints"
          :max="maxValue"
          :radius="6"
          :min="minValue"
          :gradient="heat"
        ></bml-heatmap>
      </baidu-map>
    </div>
  </div>
</template>

<script>
import { BmlHeatmap } from "vue-baidu-map";
import dayjs from "dayjs";

function formatNumber(num) {
  return num < 10 ? "0" + num : num + "";
}
export default {
  name: "HistoryMap",
  components: {
    //注册
    BmlHeatmap,
  },
  data() {
    return {
	  isFirst:0,
      silderVisible: false,
      isPlay: false,
      timePos: 0,
      descedPoints: [], //所有描绘的点
      todayAllPoints: [], //当日所有时间段点
      stepNum: 0, //阶梯段
      visible: true,
      markerPo: {},
      heat: {
        0.3: "rgb(0, 255, 0)",
        0.6: "rgb(255, 255, 0)",
        0.9: "rgb(225, 75, 0)",
      },
      maxSlider: 24,
      // points: [],
      points: [
        {
          lat: "31.87950585196751",
          lng: "118.83080420247896",
          count: "33.59",
        },
        {
          lat: "31.87950585196751",
          lng: "118.83080420247896",
          count: "33.61",
        },
      ],
      maxValue: 10,
      minValue: 1,
      options: [
        {
          value: 1,
          label: "空气温度",
        },
        {
          value: 2,
          label: "空气湿度",
        },
        {
          value: 3,
          label: "大气压强",
        },
        {
          value: 4,
          label: "光照强度",
        },
        {
          value: 5,
          label: "风向",
        },
        {
          value: 6,
          label: "风速",
        },
        {
          value: 7,
          label: "降雨量",
        },
        {
          value: 9,
          label: "PM 2.5",
        },
        {
          value: 10,
          label: "PM 10",
        },
        {
          value: 14,
          label: "臭氧",
        },
        {
          value: 15,
          label: "一氧化碳",
        },
        {
          value: 16,
          label: "二氧化硫",
        },
        {
          value: 17,
          label: "二氧化氮",
        },
      ],
      deviceTypeList: [
        {
          value: 1,
          label: "车载",
        },
        {
          value: 2,
          label: "气象站",
        },
      ],
      deviceType: 1,
      value: 1,
      endDate: "",
      startDate: "",
      value1: dayjs().format("YYYY-MM-DD"),
      startHour: "01",
      endHour: "23",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      timeSection: 24,
      marks: {
        0: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "00:00"),
        },
        1: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "01:00"),
        },
        2: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "02:00"),
        },
        3: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "03:00"),
        },
        4: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "04:00"),
        },
        5: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "05:00"),
        },
        6: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "06:00"),
        },
        7: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "07:00"),
        },
        8: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "08:00"),
        },
        9: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "09:00"),
        },
        10: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "10:00"),
        },
        11: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "11:00"),
        },
        12: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "12:00"),
        },
        13: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "13:00"),
        },
        14: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "14:00"),
        },
        15: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "15:00"),
        },
        16: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "16:00"),
        },
        17: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "17:00"),
        },
        18: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "18:00"),
        },
        19: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "19:00"),
        },
        20: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "20:00"),
        },
        21: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "21:00"),
        },
        22: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "22:00"),
        },
        23: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "23:00"),
        },
        24: {
          style: {
            width: "40px",
          },
          label: this.$createElement("span", "24:00"),
        },
      },
    };
  },
  created() {
    this.changeSomeThing();
    // console.log(dayjs().format("MM-DD-YYYY"))
  },
  mounted() {
    // const nowDate = new Date();
    // const date = {
    //   year: nowDate.getFullYear(),
    //   month: nowDate.getMonth() + 1,
    //   date: nowDate.getDate(),
    //   hour: nowDate.getHours(),
    // };
    // const newmonth = date.month > 10 ? date.month : "0" + date.month;
    // const day = date.date > 10 ? date.date : "0" + date.date;
    // const hour = date.hour > 10 ? date.hour : "0" + date.hour;
    // this.maxSlider = hour;
    // this.timeSection = hour;
    // this.startDate = date.year + "-" + newmonth + "-" + day + " 00:00";
    // this.endDate = date.year + "-" + newmonth + "-" + day + " " + hour + ":59";
    // this.getPoints(1);
  },
  watch: {
    timePos: function (newVal, oldVal) {
      const newPos = newVal + 1;
      this.descedPoints = [];
      for (var i = 0; i < newPos; i++) {
        this.descedPoints = this.descedPoints.concat(
          this.todayAllPoints[i] ? this.todayAllPoints[i].latLong : []
        );
      }
    },
  },
  methods: {
    formatTooltip(val) {
      return this.todayAllPoints[val-1] ? this.todayAllPoints[val-1].startTime : "";
    },
    play() {
      if (this.isPlay) {
        clearInterval(this.timer);
      } else {
        if (this.timePos == this.endStep) {
          this.timePos = 1;
        }
        this.timer = setInterval(() => {
          this.timePos++;
          if (this.timePos >= this.endStep) {
            clearInterval(this.timer);
            this.isPlay = false;
          }
        }, 1000);
      }
      this.isPlay = this.isPlay ? false : true;
    },
    changeSomeThing() {
	  this.descedPoints = [];
      this.isPlay = false;
      this.silderVisible = false;
      this.visible = false;
      clearInterval(this.timer);
      this.timer = false;
      this.maxSlider =
        this.value1 == dayjs().format("YYYY-MM-DD")
          ? new Date().getHours()
          : 24;
      this.timeSection = [1, this.maxSlider];

      this.section([1, this.maxSlider]);
	  this.play();
    },
    async getPoints(type) {
      const startDate = `${this.value1} ${this.startHour}:00:00`;
      const endDate = `${this.value1} ${this.endHour}:59:59`;
      let result = await this.request.post("/v1.0/car/getGroupHeatData", {
        type: type,
        startDate: startDate,
        endDate: endDate,
      });
      for (let v of result.data.dataList) {
        for (let m of v.latLong) {
          m.lng = parseFloat(m.lng) + 0.012;
          m.lat = parseFloat(m.lat) + 0.004;
          m.count = parseFloat(m.count);
          m.startTime = v.startTime;
          m.endTime = v.endTime;
        }
      }
      this.todayAllPoints = result.data.dataList;
     
	  if(this.isFirst<=0){
		this.descedPoints = this.descedPoints.concat(...this.todayAllPoints.map(item=>item.latLong))
	  }
	  this.isFirst++;
	  setTimeout(()=>{
		this.visible = true;
	    this.$forceUpdate();
        
	  },1000)
	//   this.$nextTick(() => {
    //     this.visible = true;
    //   });
      this.silderVisible = true;
        this.maxValue = parseFloat(result.data.maxValue);
        this.minValue = parseFloat(result.data.minValue);
    },
    choiceType(e) {
      this.changeSomeThing();
      //   this.getPoints(e);
    },
    choiceTime(e) {
      this.changeSomeThing();
      //   this.getPoints(this.value);
    },
    section(e) {
      const end = (e[1] - e[0]) * 12;
      this.endStep = end;
      this.stepNum = end;
      this.timePos = end;
      this.startHour = formatNumber(e[0]);
      this.endHour = formatNumber(e[1] - 1);
      this.getPoints(this.value);
    },
  },
};
</script>

<style scoped>
@import url("../../assets/css/common.css");

.Map_box {
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  height: 600px;
}

.screen_box {
  display: flex;
  width: 90%;
  float: right;
}

.screen_box .creatadd {
  margin-top: 6px;
  margin-left: 30px;
}

.screen_box .el-date-editor .el-range-separator {
  width: 20px;
}

.screen_title {
  font-size: 12px;
  color: #666;
  padding: 0 15px;
}

.operation {
  display: flex;
  background-color: #f6f6f6;
  padding: 15px 40px;
  margin-bottom: 20px;
}

.block {
  width: 99%;
}
.flex-block {
  display: flex;
  width: 100%;
}

.el-slider__marks div {
  width: 50px !important;
}
</style>
